import { useState } from 'react';

interface OpenedDocument {
  billingUuid: string;
  attachmentId: number;
}

// Tracks the attachment opened in the document viewer of the billing drawer
export const useOpenedBillingDocument = (
  billingUuid: string,
  isOpen: boolean,
) => {
  const [openedDocument, setOpenedDocument] = useState<OpenedDocument>();

  const openedDocumentId =
    isOpen && openedDocument?.billingUuid === billingUuid
      ? openedDocument.attachmentId
      : undefined;

  const toggleDocument = (attachmentId: number) => {
    setOpenedDocument(
      openedDocumentId === attachmentId
        ? undefined
        : { billingUuid, attachmentId },
    );
  };

  const closeDocument = () => {
    setOpenedDocument(undefined);
  };

  return { openedDocumentId, toggleDocument, closeDocument };
};
